class EarlyAccessValidation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const formElement = this.querySelector("form");
    if (!!formElement) {
      formElement.addEventListener('submit', (event) => {
        event.preventDefault();
        const formData = new FormData(formElement);
        fetch(window.routes.cart_update_url + ".js", {
          method: "POST",
          credentials: "same-origin",
          body: formData,
        })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            const error_string = `\nCART GET FAILED \nStatus: ${response.status} \nMessage: ${response.message} \nDescription: ${response.description}`;
            throw new Error(error_string, { cause: "Cart Error" });
          } else {
            // Wenn das ausgefuellt ist, weiß ich, dass wir in einem redirect sind --> entweder erster Besuch ODER Passwort ist inkorrekt
            const returnUrl = localStorage.getItem('currentLocation');
            localStorage.removeItem("currentLocation");
            window.location.href = returnUrl;
          }
        })
        .catch((error) => {
          console.error(error);
        })
      })
    }
  }
}

customElements.define("early-access-validation", EarlyAccessValidation);